import { IRecord } from '@triggered/common';

export type Reference<TRecord extends IRecord, TReferencedFields extends Partial<TRecord> = {}> = {ref: any} & Required<TReferencedFields>;
